import React, { memo } from "react"
import { StyledPracticeNameTitle } from "./style"
import { PracticeBarProps } from "./types"

function PracticeName({ practice }: PracticeBarProps): JSX.Element {
  return (
    <StyledPracticeNameTitle color="inherit" variant="h1" component="h1">
      {practice.name}
    </StyledPracticeNameTitle>
  )
}

export default memo(PracticeName)
